import "./IconForward.scss";
import { ReactComponent as IconForwardComponent } from "./svg/icon_forward.svg";

export const IconForward = () => {
  return <IconForwardComponent />;
};
